import { render, staticRenderFns } from "./memberPoint.vue?vue&type=template&id=855c153a&scoped=true&"
import script from "./memberPoint.vue?vue&type=script&lang=js&"
export * from "./memberPoint.vue?vue&type=script&lang=js&"
import style0 from "./memberPoint.vue?vue&type=style&index=0&id=855c153a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "855c153a",
  null
  
)

export default component.exports